import { defineStyle } from '@chakra-ui/react';

export const toggleIconVariant = defineStyle({
  display: 'flex',
  cursor: 'pointer',
  border: '2px solid',
  backgroundColor: 'transparent',
  borderColor: 'neutral.800 !important',
  boxSizing: 'border-box',
  height: '32px',
  width: '32px',
  transition: 'none',
  _icon: {
    color: 'neutral.500',
  },
  '&[data-active="true"]:not(:disabled)': {
    backgroundColor: 'neutral.800',
    borderColor: 'neutral.850 !important',
    _icon: {
      color: 'inherit',
    },
  },
  _disabled: {
    opacity: 0.5,
  },
  '&:hover:not(:disabled):not([data-disabled])': {
    borderColor: 'skyBlue !important',
  },
});
